import type { Property } from '../../@types/vehicle-properties';

import compareProperties from './compare-properties';

const ORDER = Object.freeze({
  manufacturer: 1,
  modelSeries: 2,
  modelName: 3,
  modelYear: 4,
  manufactureYear: 5,
  mileage: 6,
  gearboxType: 7,
  colorName: 8,
  registrationNumber: 9,
  vinNumber: 10,
  fuelTypes: 11,
  engineBaseType: 12,
  chassis: 13,
  segment: 14,
  annualTax: 15,
  annualMalus: 16,
  annualBonus: 17,
});

const compareByPredefinedOrder = (firstId: string, secondId: string) => {
  const firstOrder = ORDER[firstId as keyof typeof ORDER] || Number.MAX_SAFE_INTEGER;
  const secondOrder = ORDER[secondId as keyof typeof ORDER] || Number.MAX_SAFE_INTEGER;

  if (firstOrder < secondOrder) {
    return -1;
  } else if (secondOrder < firstOrder) {
    return 1;
  }
  return 0;
};

export default (first: Property, second: Property) => {
  const result = compareByPredefinedOrder(`${first.key}`, `${second.key}`);

  if (result !== 0) {
    return result;
  }

  return compareProperties(first, second);
};
